var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#home_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M24.515 11.811 14.165 1.466 13.47.773a.844.844 0 0 0-1.19 0L1.239 11.81a1.71 1.71 0 0 0-.504 1.232c.011.943.796 1.696 1.739 1.696H3.61v8.724h18.53v-8.724h1.163c.458 0 .89-.18 1.213-.504a1.7 1.7 0 0 0 .501-1.213c0-.456-.179-.887-.503-1.211m-10.138 9.723h-3V16.07h3zm5.836-8.724v8.724h-4.122v-6.107c0-.592-.48-1.071-1.072-1.071h-4.285c-.592 0-1.072.48-1.072 1.071v6.107H5.54V12.81H2.968l9.911-9.903.619.62 9.29 9.283z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.875 0h24v24h-24z"
  })))));
};
export default SvgHome;